import { render, staticRenderFns } from "./ShiftCalendar.vue?vue&type=template&id=d0c63024&"
import script from "./ShiftCalendar.vue?vue&type=script&lang=js&"
export * from "./ShiftCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCalendar,VMain})
